export default "__VITE_ASSET__Bf3vhqBK__"